import { render, staticRenderFns } from "./ArtigosTabela.vue?vue&type=template&id=5ddf6953"
import script from "./ArtigosTabela.vue?vue&type=script&lang=js"
export * from "./ArtigosTabela.vue?vue&type=script&lang=js"
import style0 from "./ArtigosTabela.vue?vue&type=style&index=0&id=5ddf6953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports